import type { MiddlewareFactory } from "@pharaday/auth";
import type { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";

import type { Namespace } from "../../core/domain/entities";

export type NextCookiesFn = () => Promise<ReadonlyRequestCookies>;

export abstract class NamespaceProvider {
  public static readonly COOKIE_NAMESPACE_ID = "x-namespace-id";
  abstract withNamespaceMiddleware: MiddlewareFactory;
  abstract listAccessibleNamespaces(): Promise<Namespace[]>;
  abstract getCurrentNamespaceId(cookies?: NextCookiesFn): Promise<string | undefined>;
}
